import { render, staticRenderFns } from "./annotation-list-item-add-comment.vue?vue&type=template&id=a1fa09aa&"
import script from "./annotation-list-item-add-comment.vue?vue&type=script&lang=js&"
export * from "./annotation-list-item-add-comment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports